(() => {
  function balance(root) {
    const buttons = [...root.querySelectorAll('.product-option--color .option-rail button, [data-option-kind="size"] .option-rail button')];
    if (!buttons.length) return;
    buttons.forEach(button => { button.style.height = 'auto'; });
    const height = Math.ceil(Math.max(...buttons.map(button => button.getBoundingClientRect().height)));
    buttons.forEach(button => { button.style.height = `${height}px`; });
  }
  function init() {
    document.querySelectorAll('.product-page.is-fashion-product').forEach(root => {
      let lastWidth = 0;
      let frame;
      const update = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(() => balance(root)); };
      const observer = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width !== lastWidth) { lastWidth = width; update(); }
      });
      observer.observe(root);
      document.fonts.ready.then(update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
